(() => {
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // assets/js/acolyte.js
  var require_acolyte = __commonJS({
    "assets/js/acolyte.js"(exports) {
      var el = document.getElementsByClassName("PlayVideo");
      var video_wrapper = document.getElementsByClassName("VideoWrapper");
      var video = document.getElementsByClassName("VideoTag");
      var play_button = document.getElementsByClassName("PlayBtn");
      var replay_button = document.getElementsByClassName("ReplayBtn");
      function scrollContent() {
        var totalScroll = jQuery(document).height() - jQuery(window).height();
        newScroll = jQuery(window).scrollTop();
        currentScroll = newScroll;
        jQuery(".ToAnim").each(function() {
          var object = jQuery(this);
          if (newScroll + jQuery(window).height() * 1 > jQuery(this).offset().top) {
            object.addClass("IsAnim");
            object.removeClass("DoneAnim");
          } else if (newScroll + jQuery(window).height() < jQuery(this).offset().top) {
            object.removeClass("IsAnim");
            object.addClass("DoneAnim");
          }
        });
      }
      function slideAccordion(typeSlide, accordion) {
        switch (typeSlide.toLowerCase()) {
          case "up":
            accordion.removeClass("active");
            accordion.next().slideUp(200);
            break;
          case "down":
            accordion.addClass("active");
            accordion.next().slideDown(200);
            break;
          case "toggle":
            accordion.toggleClass("active");
            accordion.next().slideToggle(200);
            break;
        }
      }
      function TheToggler(mainValue, self) {
        var on = "is-active";
        jQuery("[data-toggler]").each(function() {
          if (jQuery(this).attr("data-toggler") == mainValue) {
            jQuery(this).toggleClass(on);
          }
        });
        jQuery("[data-toggle]").each(function() {
          var value = jQuery(this).attr("data-toggle");
          if (mainValue == value) {
            jQuery(this).toggleClass(on);
          }
        });
      }
      function handle_loading_msg_button(form, loading) {
        var submit_button = form.find('button[type="submit"]');
        var span_loading_msg = submit_button.parent().find("span").text();
        var span_msg = submit_button.text();
        if (loading) {
          submit_button.addClass("disabled");
        } else {
          submit_button.removeClass("disabled");
        }
        submit_button.parent().find("span").text(span_msg);
        submit_button.text(span_loading_msg);
      }
      function click_video(e) {
        var el2 = el;
        var el2 = e.srcElement;
        var parent = el2.offsetParent;
        var vid = parent.getElementsByClassName("VideoTag")[0];
        vid.play();
        parent.classList.add("is-playing");
      }
      function clickPlay() {
        for (var i = 0; i < el.length; i++) {
          var play_btn = play_button[i];
          play_btn.addEventListener("click", function(e) {
            click_video(e);
          });
        }
      }
      function click_video_replay(e) {
        var el2 = el;
        var el2 = e.srcElement;
        var parent = el2.offsetParent;
        var vid = parent.getElementsByClassName("VideoTag")[0];
        vid.pause();
        vid.currentTime = "0";
        vid.play();
      }
      function clickReplay() {
        for (var i = 0; i < el.length; i++) {
          var replay_btn = replay_button[i];
          replay_btn.addEventListener("click", function(e) {
            click_video_replay(e);
          });
        }
      }
      function playVideo() {
        var scrolled_y = window.scrollY;
        var screenHeight = window.screen.height;
        for (var i = 0; i < el.length; i++) {
          var item = el[i];
          var vid = video[i];
          var vid_wrapper = video_wrapper[i];
          if (scrolled_y + screenHeight > item.offsetTop + screenHeight) {
            if (!vid_wrapper.classList.contains("is-playing")) {
              vid_wrapper.classList.add("is-playing");
              vid.play();
            }
          }
        }
      }
      function subnavToggle() {
        var nav = document.querySelector(".js-main-nav");
        var navItemsChildren = nav.querySelectorAll(".menu-item-has-children");
        var screenWidth = window.innerWidth;
        navItemsChildren.forEach(function(navItem, index) {
          navItem.addEventListener("click", function(e) {
            if (navItem.classList.contains("is-active")) {
              navItem.classList.remove("is-active");
            } else {
              navItem.classList.add("is-active");
            }
          });
        });
      }
      function calendarLoad() {
        var calendarEl = document.getElementById("calendar");
        if (calendarEl) {
          var urlObj = new URL(window.location.href);
          var newUrlObj = new URL(window.location.href);
          var todayObj = new Date();
          var today = todayObj.toLocaleDateString("en-CA");
          var sectionId = document.getElementsByClassName("js-events-results")[0].id;
          var myCalendar = jsCalendar.new({
            target: calendarEl,
            navigator: true,
            navigatorPosition: "both",
            zeroFill: true,
            monthFormat: "month YYYY",
            dayFormat: "D",
            language: document.body.dataset.lang
          });
          myCalendar.onDateRender(function(date, element, info) {
            var calendarDate = date.getTime();
            var queryDate = date.toLocaleDateString("en-CA");
            if (element.classList.contains("jsCalendar-previous") || element.classList.contains("jsCalendar-next")) {
              return;
            }
            if (urlObj.search && urlObj.search == "?date=" + queryDate || !urlObj.search && queryDate == today) {
              element.classList.add("is-active");
            }
            if (eventsDates.includes(calendarDate)) {
              element.classList.add("has-event");
            }
          });
          myCalendar.onDateClick(function(event, date) {
            var calendarDate = date.getTime();
            if (eventsDates.includes(calendarDate)) {
              var queryDate = date.toLocaleDateString("en-CA");
              newUrlObj.search = "?date=" + queryDate;
              newUrlObj.hash = sectionId;
              var newUrl = newUrlObj.toString();
              window.location.href = newUrl;
            }
          });
          myCalendar.refresh();
        }
      }
      function scrollToHashLocation() {
        const hashTarget = window.location.hash;
        if (!hashTarget) {
          return false;
        }
        const targetElement = document.querySelector(hashTarget);
        const targetElementTop = targetElement.getBoundingClientRect().top;
        if (targetElement) {
          window.scrollTo({
            top: window.scrollY + targetElementTop,
            left: 0,
            behavior: "smooth"
          });
        }
      }
      (function($, root, undefined) {
        $(function() {
          "use strict";
          $(document).ready(function() {
            scrollContent();
            clickPlay();
            clickReplay();
            playVideo();
            subnavToggle();
            calendarLoad();
            $('input[type="file"]').change(function(e) {
              var fileName = e.target.files[0].name;
              $(this).parent().find("label").text(fileName);
            });
            $("form").submit(function(e) {
              handle_loading_msg_button($(this), true);
            });
            var accordion = $(".Accordions");
            var accordion_length = accordion.length;
            if (accordion_length > 0) {
              var block = $(".Accordions_block");
              var header = $(".Accordions_header");
              var title = $(".Accordions_title");
              var content = $(".Accordions_content");
              header.click(function() {
                var self = $(this);
                if (!accordion.hasClass("Accordions-collapse")) {
                  var accordions_active = $(".Accordions_block .Accordions_header.active");
                  accordions_active.removeClass("active");
                  if (accordions_active.length > 0) {
                    accordions_active.next().slideUp(function() {
                      if (self[0] != $(this).prev()[0]) {
                        slideAccordion("toggle", self);
                      }
                    });
                  } else {
                    slideAccordion("toggle", self);
                  }
                } else {
                  slideAccordion("toggle", self);
                }
              });
            }
            ;
            $("[data-toggler]").click(function(e) {
              var self = $(this);
              var mainValue = $(this).attr("data-toggler");
              TheToggler(mainValue, self);
              e.preventDefault();
            });
            $(".SlickProcedure").slick({
              dots: false,
              prevArrow: '<button type="button" class="Btn Btn-icon Icon-center Prev" data-icon="keyboard_arrow_left"></button>',
              nextArrow: '<button type="button" class="Btn Btn-icon Icon-center Next" data-icon="keyboard_arrow_right"></button>'
            });
            $(".SlickSidebar").slick({
              dots: false,
              appendArrows: ".SlickSidebar_controls",
              prevArrow: '<button type="button" class="Btn Btn-icon Icon-center Prev" data-icon="keyboard_arrow_left"></button>',
              nextArrow: '<button type="button" class="Btn Btn-icon Icon-center Next" data-icon="keyboard_arrow_right"></button>'
            });
            var SlickTrackHeight = $(".SlickProcedure .slick-track").innerHeight();
            var SlickImgHeight = $(".SlickProcedure .slick-slide.slick-active img").innerHeight();
            var SlickLegendHeight = (SlickTrackHeight - SlickImgHeight) / 2;
            var SlickArrowsTop = "calc(50% - " + SlickLegendHeight + "px)";
            $(".SlickProcedure .slick-arrow").css("top", SlickArrowsTop);
            $(".Editable table").wrap("<div class='table-responsive'></div>");
            $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
              if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
                if (target.length) {
                  event.preventDefault();
                  $("html, body").animate({
                    scrollTop: target.offset().top - 60
                  }, 1e3, function() {
                    var $target = $(target);
                    if ($target.is(":focus")) {
                      return false;
                    } else {
                      $target.attr("tabindex", "-1");
                    }
                    ;
                  });
                }
              }
            });
            const lightbox = GLightbox({
              touchNavigation: true,
              loop: true,
              autoplayVideos: true
            });
          });
          var resizeTimer;
          $(window).on("resize", function(e) {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              var SlickTrackHeight = $(".SlickProcedure .slick-track").innerHeight();
              var SlickImgHeight = $(".SlickProcedure .slick-slide.slick-active img").innerHeight();
              var SlickLegendHeight = (SlickTrackHeight - SlickImgHeight) / 2;
              var SlickArrowsTop = "calc(50% - " + SlickLegendHeight + "px)";
              $(".SlickProcedure .slick-arrow").css("top", SlickArrowsTop);
            }, 250);
          });
          $(window).on("load", function() {
            scrollToHashLocation();
          }).scroll(function() {
            scrollContent();
            playVideo();
          });
        });
      })(jQuery, exports);
    }
  });
  require_acolyte();
})();
